import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { common } from '@/styles/styles';

import { ds } from './lib/design.system';

export const LIVE_BADGE_HEIGHT = 20;
export const LIVE_LABEL_WITH_BADGE_WIDTH = 56;

export const LiveBadge = ({ count, style }: { count: number; style: StyleProp<ViewStyle> }) => {
    return (
        <Box
            minWidth={20}
            height={20}
            borderRadius={'r6'}
            backgroundColor={ds.colorToken.background.danger.strong}
            alignItems={'center'}
            justifyContent={'center'}
            style={[common.borderCurve, style]}
        >
            <Text variant={'labelLarge'} color={ds.colorToken.text.primary} letterSpacing={-0.08}>
                {count}
            </Text>
        </Box>
    );
};
